import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import i18n from '@/i18n';
import ColorModuleSearch from '@/modules/ColorModule/components/ColorModuleSearch.vue';
import OptionalColorModuleFilters from '@/modules/ColorModule/components/OptionalColorModuleFilters.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorModuleHeader',
  props: {
    activeTab: { type: [String, Boolean], default: false },
    filters: null,
    filtersActive: { type: Boolean },
    requestFiltersActive: { type: Boolean },
    searchQuery: null,
    showLatestColors: { type: Boolean, default: false }
  },
  emits: [
    'setFiltersActiveState',
    'filterChange',
    'search',
    'clearFilters',
    'toggleLatestColors',
    'changeActiveTab',
],
  setup(__props: any, { emit }) {

const props = __props as { activeTab: string | boolean, filters: any, filtersActive: boolean, requestFiltersActive: boolean, searchQuery: string, showLatestColors: boolean };





const setFilters = (active: boolean) => {
    emit('setFiltersActiveState', active);
};

const clearFilters = () => {
    emit('clearFilters');
};

const requestTabClick = () => {
    const activeTab = props.activeTab === 'color-request' ? 'color-search' : 'color-request';
    emit('changeActiveTab', activeTab);
};

const filterActiveState = computed(() => {
    if (props.activeTab === 'color-request') {
        return props.requestFiltersActive;
    }

    return props.filtersActive;
});

const tabSwitchText = computed(() => {
    if (props.activeTab === 'color-request') {
        return i18n.t('Color Search');
    }

    return i18n.t('Color Request');
});

return { __sfc: true,props, emit, setFilters, clearFilters, requestTabClick, filterActiveState, tabSwitchText, ColorModuleSearch, OptionalColorModuleFilters }
}

})